import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
    selector: 'app-basic-modal',
    templateUrl: 'basic-modal.component.html',
})
export class BasicModal {
    @Output() onCancel = new EventEmitter<any>();
    @Input() title: string = "";
    @Output() onAccept = new EventEmitter<any>();
    constructor(
      public dialogRef: MatDialogRef<BasicModal>,
      @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    onClickCancel(event): void {
        this.dialogRef.close();
        this.onCancel.emit(event)
    }
}